(() => {
  const initReviews = () => {
    const root = document.querySelector('#judgeme_product_reviews');
    if (!root || root.dataset.solsticeReviewsReady === 'true') return false;
    const widget = root.querySelector('.jdgm-rev-widg');
    if (!widget) return false;
    const header = widget.querySelector('.jdgm-rev-widg__header');
    if (!header) return false;

    let details = widget.querySelector('.sn-review-details');
    if (!details) {
      details = document.createElement('div');
      details.className = 'sn-review-details';
      const children = Array.from(widget.children);
      const headerIndex = children.indexOf(header);
      children.slice(headerIndex + 1).filter((child) => !child.classList.contains('sn-review-toggle')).forEach((child) => details.appendChild(child));
      widget.appendChild(details);
    }

    const countSource = document.querySelector('.zz-pdp[data-review-count]');
    const count = Number(countSource?.dataset.reviewCount || 0);
    const closedLabel = count > 0 ? `Read ${count} review${count === 1 ? '' : 's'}` : 'Read reviews';
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'sn-review-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = `<span class="sn-review-toggle__label">${closedLabel}</span><span class="sn-review-toggle__mark" aria-hidden="true">+</span>`;

    details.hidden = true;
    header.insertAdjacentElement('afterend', toggle);
    root.dataset.solsticeReviewsReady = 'true';

    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      details.hidden = open;
      root.classList.toggle('is-reviews-open', !open);
      toggle.querySelector('.sn-review-toggle__label').textContent = open ? closedLabel : 'Hide reviews';
      toggle.querySelector('.sn-review-toggle__mark').textContent = open ? '+' : '−';
    });
    return true;
  };

  if (initReviews()) return;
  const observer = new MutationObserver(() => {
    if (initReviews()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 12000);
})();
